/** @format */

import React, { memo } from 'react';
import useModal from '../../../../shared/Modal';

interface VrModalProps {
  vrMedia: {
    url: string;
  };
  modalOpen: boolean;
  onSetModalClose: () => void;
}

const VrModal: React.FC<VrModalProps> = ({ vrMedia, modalOpen, onSetModalClose }) => {
  const { Modal } = useModal();
  return (
    <>
      <Modal isShow={modalOpen} onClose={() => onSetModalClose}>
        <div className="gallery-vr-container">
          <iframe src={vrMedia.url} frameBorder="0" title="vr" />
          <button onClick={onSetModalClose} type="button" className="close">
            &times;
          </button>
        </div>
      </Modal>
    </>
  );
};

export default memo(VrModal);
